import { IoCheckmark } from "react-icons/io5";
import { useAvtarList } from "../../../store/api/useAvtarList";
import { updateSpesificUserData } from "../../../store/Slices/UserSlice";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { ClipLoader } from "react-spinners";
import { useTheme } from "../../../context/ThemeProvider";
import TextTranslate from "../../../utils/TextTranslate";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFile } from "../../../context/FileProvider";

export default function SelectAvtar() {
  const { data: avtarData, isLoading } = useAvtarList();
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state.userData);
  // @ts-ignore
  const { theme } = useTheme();
  const location = useLocation();
  const { setSelectedFile } = useFile();

  useEffect(() => {
    if (
      avtarData?.data?.Records?.length > 0 &&
      location.pathname == "/select-profile"
    ) {
      dispatch(
        updateSpesificUserData({
          avatar_path: avtarData?.data?.Records[0].avatar_media,
        }),
      );
    }
  }, [avtarData?.data?.Records, location.pathname]);

  return (
    <div className="overflow-hidden rounded-2xl bg-secondary p-4 shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      <div className="mb-3 text-[13px] font-medium uppercase tracking-wide text-lightText">
        <TextTranslate text="Choose Avtar" />
      </div>
      <div className="avtar-containar flex gap-3 overflow-x-auto pb-1">
        {isLoading ? (
          <div className="grid h-24 w-full place-content-center">
            <ClipLoader
              size={23}
              color={theme == "dark" ? "white" : "black"}
            />
          </div>
        ) : (
          avtarData?.data?.Records.map((avtar) => {
            const selected = userData.avatar_path == avtar.avatar_media;
            return (
              <button
                type="button"
                key={avtar.avatar_media}
                onClick={() => {
                  setSelectedFile(null);
                  dispatch(
                    updateSpesificUserData({
                      avatar_path: avtar.avatar_media,
                    }),
                  );
                }}
                className="relative h-20 w-20 shrink-0"
              >
                <img
                  className={`h-full w-full rounded-full object-cover ${
                    selected
                      ? "ring-2 ring-themeColor ring-offset-2 ring-offset-secondary"
                      : "ring-1 ring-black/10 dark:ring-white/15"
                  }`}
                  src={avtar.avatar_media}
                  alt=""
                />
                {selected && (
                  <span className="absolute bottom-0 right-0 grid h-6 w-6 place-content-center rounded-full bg-themeColor text-themeTextColor shadow-sm">
                    <IoCheckmark className="text-sm" />
                  </span>
                )}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
